<!-- 查看拜访记录 -->
<template>
    <!--添加界面-->
      <el-dialog class="model-visit-form-view" width="850px" title="拜访详情" :visible.sync="myVisible" :destroy-on-close="true" @close="handerClose"
        :close-on-click-modal="false">
        <el-row :gutter="24" class="toolbar" v-if="myDetail">
          <el-form  label-width="110px" label-position="left"  ref="ruleForm" >
            <el-col :span="24">
              <el-form-item label="拜访客户："> {{ $route.query.companyName || myDetail.companyName}} </el-form-item>
            </el-col>  

            <el-col :span="12">
              <el-form-item label="客户经理：">{{ myDetail.adminUserName }} </el-form-item>
            </el-col>  
            <el-col :span="12">
              <el-form-item label="客户成功经理：">{{ myDetail.successfulManagerName||'-' }} </el-form-item>
            </el-col>  

            <el-col :span="12">
              <el-form-item label="经销商：">{{ myDetail.agencyManagerName ||'-'}} </el-form-item>
            </el-col>  


            <el-col :span="12">
              <el-form-item label="拜访日期：" >{{ myDetail.payVisitDate?  myDetail.payVisitDate.split(" ")[0]: '-' }}</el-form-item>
            </el-col>  

            <el-col :span="12">
              <el-form-item label="联系人：" >{{ myDetail.contactUser }} </el-form-item>
            </el-col>  

            <el-col :span="12">
              <el-form-item label="联系方式：" > {{ myDetail.contactPhone }} </el-form-item>
            </el-col>  

            <el-col :span="12">
              <el-form-item label="职位：" >{{ myDetail.position || '-' }}</el-form-item>
            </el-col> 

            <el-col :span="12">
              <el-form-item label="拜访方式：" >
                  <span class="myTag-fill" :class="myDetail.payVisitStatus == 1? 'pruple': (myDetail.payVisitStatus == 2? 'primary' :'warning')" >
                    {{ myDetail.payVisitStatus == 1? "电话沟通": (myDetail.payVisitStatus == 2? '客户现场': '视频会议') }}
                  </span>
              </el-form-item>
            </el-col> 

            <el-col :span="24">
              <el-form-item label="客户地址：" >{{ myDetail.addressInfo }}</el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="拜访详情：" >{{ myDetail.payVisitInfo || '-' }}</el-form-item>
            </el-col> 
            
            <el-col :span="24">
              <el-form-item label="现场照片：" >
                <PictureList :pictureList="myDetail.picList" v-if="myDetail.picList.length > 0" />
                <span v-else>-</span>
              </el-form-item>
            </el-col> 
            

            <el-col :span="12">
              <el-form-item label="审核状态：" >
                 <span class="myTag" :class="[myDetail.auditStatus == 1? 'warning': 'primary' ]" >
                    {{ myDetail.auditStatus == 1? "待审核": '已审核'}}
                  </span>
              </el-form-item>
            </el-col> 

          </el-form>
        </el-row>
        <el-divider> <span class="dividerSpan">评论（{{commentList.length}}）</span> </el-divider>
        <div class="commentBox">
          <div class="list">
            
          <div class="item" v-for="item in commentList" :key="item.id">
            <!-- 头像 -->
            <div class="avatar"></div>
            <!-- 右侧主体部分 -->
            <div class="itemInfo">
              <div class="info">
                <span class="name">{{ item.username || '-' }}</span>
                <span class="time">{{ item.intime || '-' }}</span>
              </div>
              <div class="content">{{ item.note || '-' }}</div>
              <div class="actionBox">
                <span v-if="item.userid != userInfo.id" class="dnnfont iconcomment-dots" @click="reply(item)">&nbsp;回复</span>
                <span v-if="item.userid === userInfo.id" class="dnnfont icondelete" @click="deleteComment(item)">&nbsp;删除</span>
              </div>
            </div>
          </div>
          </div>
          <el-input v-if="userInfo.type == 1 && !isReply" type="textarea" rows="3" v-model="commentNote" placeholder="请输入"></el-input>
          <el-input v-if="isReply" type="textarea" rows="3" v-model="replyNote" :placeholder="'回复 '+ replyObj"></el-input>
          <div class="btnBox">
            <el-button v-if="userInfo.type == 1 && !isReply" type="primary" @click.native="postComment" :loading="postLoading">发表评论</el-button>
            <el-button v-if="isReply" @click.native="closeReply">取消</el-button>
            <el-button v-if="isReply" type="primary" @click.native="replyComment" :loading="postLoading">回复</el-button>
          </div>
        </div>

        <!-- 1/ 待审核 2、管理员审核  && myDetail.auditStatus == 1-->
        <div slot="footer" class="dialog-footer" style="text-align:center" v-if="myDetail && userInfo.type == 1  && myDetail.auditStatus == 1 ">
          <el-button @click.native="handerClose">取消</el-button>
          <el-button type="primary" @click.native="handerSubmit(myDetail)" :loading="confirmLoading">审核通过</el-button>
        </div>

      </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_userCom } from '@/api/index.js'
import  utils  from '@/utils/index'
import PictureList from '@/components/PictureList'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: () => null
    }
  
  },

  data () {
    return {
     
      listLoading: false,
      confirmLoading: false,
      
      token:'',
      checkCode:'',
      myDetail: null,
      myVisible: false,
      commentNote:undefined,
      postLoading:false,
      commentList:[],
      isReply:false,
      replyObj:'',
      replyNote:undefined
    };
  },

  components: {
    PictureList
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  }, 
 
  created() {
    this.myVisible = this.visible
  },

  mounted() {
    let { token, checkCode } = utils.getParamsByCookie();
    this.token = token;
    this.checkCode = checkCode;
    this.myDetail = JSON.parse(JSON.stringify(this.processDetail))
    this.getCommentList()
  },

  methods: {

  
 
    // 审核
    handerSubmit(processInfo) {
      let data = JSON.parse(JSON.stringify(processInfo))
      //  let date =  data.payVisitDate;
      //  data.payVisitDate = date.indexOf('00:00:00') > -1? date: (date + ' 00:00:00')
      //  delete data.contactUserName;
      //  delete data.adminUserName;
      //  data.auditStatus = '2';
      let param = {
        id: data.id,
        auditStatus: '2',
        companyId: data.companyId,
      }
       API_userCom.updateTrack(param).then(res => {
          if(res.data.code == 200) {
            this.$message.success('审核成功');
            this.$emit('getList')
            this.handerClose();
          }
          this.confirmLoading = false;
        }).catch( err => {
          this.confirmLoading = false;
        })
    },

  

    handerClose() {
      console.log('handerCLose=')
      this.myVisible = false;
      this.$emit('update:visible', false)
    },
    // 获取所有评论
    getCommentList(){
      console.log('userInfo',this.userInfo);
      let marketid = this.myDetail.id
      API_userCom.getComment(marketid).then(res => {
          if(res.data.code == 200) {
            this.commentList = res.data.data
            let listDom = document.getElementsByClassName('list')
            console.log(218,listDom);
            listDom[0].scrollTop = 0
          }
        }).catch( err => { })
    },
    // 发表评论
    postComment(){
      this.postLoading = true
      let params = {
        marketid: this.myDetail.id,
        userid: this.userInfo.id,
        note: this.commentNote
      } 
      API_userCom.addComment(params).then(res => {
          if(res.data.code == 200) {
            this.$message.success('评论成功');
            this.commentNote = undefined
            this.getCommentList()
          }else{
            this.$message.error(res.data.message);
          }
          this.postLoading = false;
        }).catch( () => {
          this.postLoading = false;
        })
    }, 
    // 删除评论（目前只允许删除自身的评论）
    deleteComment(item){
      console.log(item,this.userInfo.id);
      if(item.userid != this.userInfo.id){
        this.$message.warning('不允许删除别人的评论');
        return false
      }
      API_userCom.delComment(item.id).then(res => {
        console.log('delComment',res);
          if(res.data.code == 200) {
            this.$message.success('删除成功');
            this.getCommentList()
          }else{
            this.$message.error(res.data.message);
          }
        }).catch( () => { })
    },
    // 回复操作
    reply(item){
      if(item.userid != this.userInfo.id){
        this.replyObj = item.username
        this.isReply = true
      }
    },
    // 取消回复
    closeReply(){
      this.isReply = false
      this.replyObj = ''
    },
    // 回复
    replyComment(){
      this.postLoading = true
      let params = {
        marketid: this.myDetail.id,
        userid: this.userInfo.id,
        note: this.replyNote
      } 
      API_userCom.addComment(params).then(res => {
          if(res.data.code == 200) {
            this.$message.success('回复成功');
            this.replyNote = undefined
            this.isReply = false
            this.replyObj = ''
            this.getCommentList()
          }else{
            this.$message.error(res.data.message);
          }
          this.postLoading = false;
        }).catch( () => {
          this.postLoading = false;
        })
    }
  }
}

</script>
<style lang='scss' scoped>
.model-visit-form-view {
  .el-form-item {
    margin-bottom: 0;
  }
  .dividerSpan{
    font-size: 14px;
    color: #9c9c9c;
  }
  .commentBox{
    .list{
      max-height: 300px;
      margin-bottom: 8px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .item{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 24px;
      .avatar{
        margin-right: 8px;
        width: 24px;
        height: 24px;
        background: url('../../../../assets/avatar.svg') center;
        background-size: contain;
      }
      .itemInfo{
        flex: 1;
        padding-top: 2px;
        .info{
          height: 22px;
          margin-bottom: 4px;
          .name{
            line-height: 22px;
            font-size: 14px;
            font-weight: 600;
            color: #333333;
            margin-right: 14px;
          }
          .time{
            line-height: 20px;
            font-size: 12px;
            font-weight: 400;
            color: #9c9c9c;
          }
        }
        .content{
          line-height: 22px;
          color: #333333;
          font-size: 14px;
          font-weight: 400;
        }
        .actionBox{
          margin: 4px 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .dnnfont{
            margin-right: 12px;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #666;
            cursor: pointer;
            -webkit-user-select: none;  /* Chrome, Safari, Edge, Opera */  
            -moz-user-select: none;     /* Firefox */  
            -ms-user-select: none;      /* IE 10+ */  
            user-select: none;          /* Standard syntax */  
          }
          .dnnfont:hover{
            color: #558FE5;
          }
        }
      }
    }
    .btnBox{
      margin-top: 12px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ModalFormView.vue?26807b3a